import { TAG_NOTIFICATIONS, TAG_PROJECT, TAG_PROJECT_USERS, TAG_PROJECTS } from "src/api/api-tags";
import {
  CreateProjectRequest,
  CreateProjectResponse,
  GetProjectResponseProject,
  GetProjectSettingsResponse,
  GetProjectsResponse,
  GetProjectUsersResponse,
  IsLoxoneAvailableResponse
} from 'src/model/api/v2/data-contracts';
import { appApiSlice } from "src/api/app-ApiSlice";
import { GetProjectNotificationsResponse } from "src/model/api/get-project-notifications-response.model";

export const projectV2ApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query<GetProjectsResponse, void>({
      query: () => ({
        url: `v2/project/get-projects`,
        method: "GET",
      }),
      providesTags: [TAG_PROJECTS],
    }),
    getProject: builder.query<GetProjectResponseProject, number>({
      query(projectId: number) {
        return `v2/project/get-project?project_id=${projectId}`;
        },
      providesTags: [TAG_PROJECT],
    }),
    getProjectSettings: builder.query<GetProjectSettingsResponse, number>({
      query: (projectId: number) => `v2/project/get-project-settings?project_id=${projectId}`,
      keepUnusedDataFor: 0,
    }),
    getProjectUsers: builder.query<GetProjectUsersResponse, number>({
      query: (projectId: number) => `v2/project/get-project-users?project_id=${projectId}`,
      keepUnusedDataFor: 0,
      providesTags: [TAG_PROJECT_USERS],
    }),
    createProject: builder.mutation<CreateProjectResponse, CreateProjectRequest>({
      query: (body) => ({
        url: `v2/project/create`,
        method: "POST",
        body,
      }),
      invalidatesTags: [TAG_PROJECTS],
    }),
    isLoxoneAvailable: builder.query<IsLoxoneAvailableResponse, number>({
      query: (projectId: number) => `v2/project/is-loxone-available/${projectId}`,
    }),
    getProjectNotifications: builder.query<GetProjectNotificationsResponse, void>({
      query: () => `/v2/project/get-project-notifications-as-objects`,
      providesTags: [{ type: TAG_NOTIFICATIONS }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProjectQuery,
  useGetProjectSettingsQuery,
  useGetProjectUsersQuery,
  useCreateProjectMutation,
  useLazyIsLoxoneAvailableQuery,
  useGetProjectNotificationsQuery,
} = projectV2ApiSlice;
